<template>
    <el-dropdown trigger="click" @command="handleCommand" v-if="actions.length">
        <a href="#" class="text-light" :class="{'large-dropdown-button':large, 'dropdown-button':!large, 'in-button':button}" @click.prevent.stop="">
            <i class="fas fa-ellipsis-v"></i>
        </a>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(action, index) in actions" :key="index" :command="index" :icon="action.icon" :divided="action.divided">
                {{ action.label }}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    export default {

        props: {

            actions: {
                type: Array,
                required: true
            },

            large: {
                type: Boolean,
                default: false
            },

            button: {
                type: Boolean,
                default: false
            }
        },

        methods: {

            handleCommand(index) {
                let action = this.actions[index]
                action.handler(action.data)
            }
        }
    }
</script>

<style>

    .el-dropdown-menu__item:focus,
    .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #f6f9fc;
        color: #16181b;
    }

    .dropdown-button {
        font-size: 1rem;
        padding: 0 0.5rem 0 0.5rem;
        margin-left: 0.25rem;
    }

    .dropdown-button i {
        position: relative;
        top: -2px;
    }

    .large-dropdown-button {
        font-size: 1.1rem;
        padding: 0.2rem 0.8rem 0.2rem 0.8rem;
    }

    .in-button i {
        top: 0;
    }

</style>
